__turbopack_context__.v({
  "date": "WeekForecast-module-scss-module__l8VboG__date",
  "dayForecast": "WeekForecast-module-scss-module__l8VboG__dayForecast",
  "icon": "WeekForecast-module-scss-module__l8VboG__icon",
  "selected": "WeekForecast-module-scss-module__l8VboG__selected",
  "temperature": "WeekForecast-module-scss-module__l8VboG__temperature",
});
